import axios from 'axios'

import Store from '../../utils/Store'
import Session from '../../model/Session'

export default class Api {

    // !!! IMPORTANT: These variables are set in public/runtime_config.js !!!
    static BASE_URL = _API_BASE_URL
    static ISPCP_URL = _ISPCP_URL
    // !!! IMPORTANT: These variables are set in public/runtime_config.js !!!

    // =================================================================================================================
    // HELPERS

    static async request(req) {
        return axios.request(req)
    }

    static async requestWithAuthentication(req) {
        console.log('From runtime config: ' + _API_BASE_URL)
        const session = Store.state.session
        if (!(session instanceof Session)) {
            throw new Error('No session is active.')
        }

        req.headers = {...req.headers, 'Authentication': session.getSessionId()}
        return axios.request(req)
    }

    // =================================================================================================================
    // /

    static getRootVersion() {
        return Api.request({
            method: 'get',
            url: `${Api.BASE_URL}/version`
        })
    }

    // =================================================================================================================
    // /auth/

    static postAuthLogin(username, password) {
        return Api.request({
            method: 'post',
            url: `${Api.BASE_URL}/auth/login`,
            data: { username: username, password: password }
        })
    }

    static postAuthCheckTwoFa(otp) {
        return Api.requestWithAuthentication({
            method: 'post',
            url: `${Api.BASE_URL}/auth/checkTwoFa`,
            data: { '2fa': otp }
        })
    }

    static getAuthLogout() {
        return Api.requestWithAuthentication({
            method: 'get',
            url: `${Api.BASE_URL}/auth/logout`
        })
    }

    // =================================================================================================================
    // /profile

    static getProfile() {
        return Api.requestWithAuthentication({
            method: 'get',
            url: `${Api.BASE_URL}/profile`
        })
    }

    // =================================================================================================================
    // /tokens

    static getTokens() {
        return Api.requestWithAuthentication({
            method: 'get',
            url: `${Api.BASE_URL}/tokens`
        })
    }

    static postTokensExists(token) {
        return Api.requestWithAuthentication({
            method: 'post',
            url: `${Api.BASE_URL}/tokens/exists`,
            data: token
        })
    }

    static putTokens(token, note) {
        return Api.requestWithAuthentication({
            method: 'put',
            url: `${Api.BASE_URL}/tokens`,
            data: { token: token, note: note }
        })
    }

    static postTokens(token, note) {
        return Api.requestWithAuthentication({
            method: 'post',
            url: `${Api.BASE_URL}/tokens`,
            data: { token: token, note: note }
        })
    }

    static deleteTokens(token) {
        return Api.requestWithAuthentication({
            method: 'delete',
            url: `${Api.BASE_URL}/tokens`,
            data: { token: token }
        })
    }

    // =================================================================================================================
    // /domains

    static getDomains(filter = null, sort = 'domain DESC', limit = 0, page = 1) {
        return Api.requestWithAuthentication({
            method: 'get',
            url: `${Api.BASE_URL}/domains`,
            data: {
                filter: filter,
                sort: sort,
                limit: limit,
                page: page
            }
        })
    }

    static getUnmappedDomains(filter = null, sort = 'origin DESC', limit = 0, page = 1) {
        return Api.requestWithAuthentication({
            method: 'get',
            url: `${Api.BASE_URL}/domains/unmapped`,
            data: {
                filter: filter,
                sort: sort,
                limit: limit,
                page: page
            }
        })
    }

    static putDomains(data) {
        return Api.requestWithAuthentication({
            method: 'put',
            url: `${Api.BASE_URL}/domains`,
            data: data
        })
    }

    static postDomains(data) {
        return Api.requestWithAuthentication({
            method: 'post',
            url: `${Api.BASE_URL}/domains`,
            data: data
        })
    }

    static deleteDomains(data) {
        return Api.requestWithAuthentication({
            method: 'delete',
            url: `${Api.BASE_URL}/domains`,
            data: data
        })
    }

    // =================================================================================================================
    // /dashboard

    static postRecordUpdateLog(filter, page = 1, limit = 10, sort = 'action_time DESC') {
        if (typeof page !== 'number' || page < 1) {
            throw new Error(`Invalid page number ${page}.`)
        }
        if (typeof limit !== 'number' || limit < 10) {
            throw new Error(`Invalid per page limit ${limit}.`)
        }
        if (typeof filter !== 'object') {
            filter = {}
        }
        
        return Api.requestWithAuthentication({
            method: 'post',
            url: `${Api.BASE_URL}/dashboard/recordUpdateLog`,
            data: { filter: filter, page: page, limit: limit, sort: sort }
        })
    }

}